// extracted by mini-css-extract-plugin
export var item = "TagPage-module--item--71e1b";
export var outer = "TagPage-module--outer--d4161";